import { configureStore } from '@reduxjs/toolkit'
import todoReducer from './features/todoslice/todoSlice'

export const store = configureStore({
  reducer: {
    todo: todoReducer,
  },
})